import { defineStore } from 'pinia'
import { ComputedRef, reactive, Ref, watch } from 'vue'
import { useCompanyAccounts } from '@/components/GraphqlDataTable/composables'
import { CompanyAccountFragment, OrganisationAccountFragment } from '@/gql/graphql'
import { ListItem } from '@/components/Workflows/Pages/Workflow/workflow'

// This is the primary fragment that we use to query accounts
export type AccountStoreType = (CompanyAccountFragment | OrganisationAccountFragment) & ListItem

interface AccountsStoreState {
  // Accounts contains a list of all accounts a user has access to. This includes organisations sub accounts and such.
  // Freelancers will also have access to their freelancer accounts.
  accounts: ComputedRef<AccountStoreType[]>
  selectedAccounts: AccountStoreType[]
  loading: Ref<boolean>
}

export const useAccountsStore = defineStore('accounts-store', (): AccountsStoreState => {
  const { accounts, loading } = useCompanyAccounts()
  const selectedAccounts: AccountStoreType[] = reactive([])

  watch(accounts, () => {
    const curAccount = accounts.value.find((account) => account.id === currentAccount.globalId)
    if (selectedAccounts.length === 0 && curAccount) {
      selectedAccounts.push(curAccount)
    }
  })

  return { accounts, selectedAccounts, loading }
})
